module.exports = {
    GIFTCARD: 'GiftCard',
};



// WEBPACK FOOTER //
// ./src/digitalpay/digital-pay-multi-select-type.constants.js